import { useCallback, useMemo, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslations } from '@lang';

type UseNotesPreferencesParams = {
  form: UseFormReturn<any>;
  fieldName?: string;
};

export function useNotesPreferences({ form, fieldName = 'notes' }: UseNotesPreferencesParams) {
  const { t } = useTranslations();
  const [notesEnabled, setNotesEnabled] = useState(false);
  const [noteValue, setNoteValue] = useState('');

  const handlePreferencesToggle = useCallback(
    (enabled: boolean) => {
      setNotesEnabled(enabled);
      if (!enabled) {
        form.setValue(fieldName, undefined);
        setNoteValue('');
      }
    },
    [form, fieldName]
  );

  const handleFreeTextChange = useCallback(
    (_categoryId: string, value: string) => {
      setNoteValue(value);
      form.setValue(fieldName, value);
    },
    [form, fieldName]
  );

  const preferenceCategories = useMemo(
    () => [
      {
        id: 'notes',
        label: t('additional.notes'),
        isFreeText: true,
        freeTextPlaceholder: t('booking.additionnalNotesPlaceholder'),
        freeTextValue: noteValue,
      },
    ],
    [t, noteValue]
  );

  return {
    notesEnabled,
    handlePreferencesToggle,
    handleFreeTextChange,
    preferenceCategories,
  };
}
